import axios from 'axios';
import SentryClient from './sentry';

interface Params {
  fileUrl: string;
}

export const parseFileToBlob = ({ fileUrl }: Params): Promise<Blob | null> =>
  axios
    .get(fileUrl, {
      responseType: 'blob',
    })
    .then((data) => data.data)
    .catch((err) => {
      SentryClient.captureError(err);
      return null;
    });

export const parseFileToBase64 = ({ fileUrl }: Params): Promise<string> =>
  new Promise((resolve) => {
    parseFileToBlob({ fileUrl })
      .then((response) => {
        if (!response) {
          resolve('');
          return;
        }

        const reader = new FileReader();

        reader.onload = () => {
          resolve(reader.result as string);
        };
        reader.readAsDataURL(response);
      })
      .catch((err) => {
        SentryClient.captureError(err);
        resolve('');
      });
  });
